import { graphql } from "../../gql";

export const CREATE_LIBRARY_IMAGE = graphql(`
  mutation LibraryImageCreate($input: CreateLibraryImagesInput!) {
    libraryImageCreate(input: $input) {
      ...LIBRARY_IMAGE_FIELDS
    }
  }
`);

export const LIBRARY_IMAGE_DELETE = graphql(`
  mutation LibraryImageDelete($libraryImageId: UUID!) {
    libraryImageDelete(libraryImageId: $libraryImageId) {
      id
    }
  }
`);
